import axios from 'axios'

import apiConfig from '../../../config/apiConfig'

export function getUserPreferences() {
  return axios.get(`${apiConfig.api.edge}/user-configs`)
}

export function saveUserPreferences(columnUpdates) {
  const request = {
    config_details: {
      applications: {
        departure_log: {
          tables: {
            departure_log: {
              columns:
                columnUpdates?.map((update, index) => {
                  return {
                    name: update.field,
                    position: index,
                    is_visible: update.isVisible,
                    is_pinned: update.pinned,
                  }
                }) ?? [],
            },
          },
        },
      },
    },
  }

  return axios.post(`${apiConfig.api.edge}/user-configs`, request)
}

export default {
  getUserPreferences,
  saveUserPreferences,
}
